import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../services/firebase-init';
import jobService from '../services/job-service';

const JobContext = createContext();
export function useJobContext() { return useContext(JobContext); }

export function JobProvider({ children }) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) {
        jobService.startListener((updatedJobs) => {
          setJobs(updatedJobs);
          setLoading(false);
        });
      } else {
        jobService.stopListener();
        setJobs([]);
        setLoading(false);
      }
    });
    return () => { unsub(); jobService.stopListener(); };
  }, []);

  const value = {
    jobs, loading, jobService,
    getJob: (id) => jobService.getJob(id),
    addJob: (data) => jobService.addJob(data),
    updateJob: (id, updates) => jobService.updateJob(id, updates),
    deleteJob: (id) => jobService.deleteJob(id),
    scheduleJob: (id, date, crew, duration) => jobService.scheduleJob(id, date, crew, duration),
    getJobsForDate: (date) => jobService.getJobsForDate(date),
    getUnscheduledJobs: () => jobService.getUnscheduledJobs(),
    getJobsByStatus: (status) => jobService.getJobsByStatus(status),
  };
  return <JobContext.Provider value={value}>{children}</JobContext.Provider>;
}
